module.exports = __webpack_public_path__ + "img/footer_icon_line.a59c8af1.svg";